// @flow

import React, { type Node } from 'react';
import { LinkButton } from '../commons/render-helpers';


export function PuntoXpressInformation(): Node {
  return (
    <>
      <h1>Sucursales para pago</h1>
      <p>Presente esta boleta en cualquier tienda credenciada PuntoXpress:</p>
      <br/>
      <FindPuntoXpressButton inverseStyle={true} buttonMessage="Ver tienda credenciada más cercana"/>
    </>
  );
}

export function FindPuntoXpressButton({ buttonMessage, inverseStyle = false }: FindPuntoXpressButtonProps): Node {
  const url = '#';

  return (
    <LinkButton inverseStyle={inverseStyle} aria-label={buttonMessage} type="primary" flat as="a" target="blank" href={url} contentDesktop={buttonMessage} contentMobile={buttonMessage} />
  );
}

type FindPuntoXpressButtonProps = {|
  buttonMessage: string,
  inverseStyle ?: boolean,
|};
